import type {
    ContainerViewModel,
    ContainerLayoutViewModel,
    WidgetTabViewModel,
    WorkspaceViewModel,
    WidgetViewModel,
} from '.';
import { DEFAULT_WIDGET_ACTIVE_BORDER_COLOR } from '../defaults/workspace';
import type { Layout, WidgetContainer, WidgetTab, Workspace } from '@thinkalpha/ui-types/contracts/workspace';

export const createWorkspaceViewModel = (workspace: Workspace, isDefaultWorkspace = false): WorkspaceViewModel => {
    return {
        permissions: workspace.permissions,
        id: workspace.id,
        isTemplate: workspace.isTemplate,
        name: workspace.name,
        layoutSettings: workspace.layoutSettings,
        description: workspace.description,
        isDirty: false,
        isUnsaved: false,
        activeContainerId: workspace.containers[0]?.id,
        containerIds: workspace.containers.map((container) => container.id),
        isDefaultWorkspace: isDefaultWorkspace,
        maximizedContainerId: workspace.maximizedContainerId,
        activeBorderColor: workspace.activeBorderColor || DEFAULT_WIDGET_ACTIVE_BORDER_COLOR,
    };
};

export const createContainerLayoutViewModel = (layout: Layout, containerId: string): ContainerLayoutViewModel => {
    return {
        ...layout,
        containerId: containerId,
    };
};

export const createContainerViewModel = (container: WidgetContainer): ContainerViewModel => {
    return {
        id: container.id,
        activeTabId: container.activeTabId ?? container.tabs[0].id,
        tabIds: container.tabs.map((tab) => tab.id),
    };
};

export const createTabViewModel = <T extends WidgetViewModel = WidgetViewModel>(
    tab: WidgetTab,
    widget: T,
    isActive: boolean,
    containerId: string,
): WidgetTabViewModel => {
    return {
        id: tab.id,
        name: tab.name,
        widget,
        isActive,
        containerId: containerId,
        channelId: tab.widget.channelId || null,
    };
};
